import {
  createComponent,
  EnvironmentInjector,
  inject,
  Injector,
  Type,
  reflectComponentType,
} from '@angular/core';

export abstract class TemplateResolver<T, Options extends { optional: boolean }> {
  public abstract contentDirective?: T;
  public abstract injectedComponent: Type<{ directive: T }> | null;
  public abstract defaultComponent: Options['optional'] extends true
    ? null
    : Type<{ directive: T }>;

  private injector = inject(Injector);
  private envInjector = inject(EnvironmentInjector);

  public resolve(): Options['optional'] extends true ? T | null : T {
    const isComponentClass = this.injectedComponent && reflectComponentType(this.injectedComponent);
    if (this.contentDirective) {
      return this.contentDirective;
    } else if (isComponentClass || this.defaultComponent) {
      const componentRef = this.create(this.injectedComponent! ?? this.defaultComponent!);
      componentRef.changeDetectorRef.detectChanges();
      return componentRef.instance.directive;
    } else {
      return <any>null;
    }
  }

  public create(cmp: Type<{ directive: T }>) {
    return createComponent(cmp, {
      environmentInjector: this.envInjector,
      elementInjector: this.injector,
    });
  }

  public isProjected() {
    return !!this.contentDirective;
  }
}
